


import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import { toast } from 'react-toastify';
import AnalyticsModal from './AnalyticsModal';
import { useNavigate } from "react-router-dom"

const Analytics = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);
    const [user, setUser] = useState([])
    const [video, setVideo] = useState([])
    const [loading, setLoading] = useState(false);

    const [image, setImage] = useState("");
    const [preImage, setPreImage] = useState("");
    const token = localStorage.getItem("token");
    const [data, setData] = useState({
        user_id: "",
        user_name: "",
        view_type: "",
        video_id: "",
        video: "",
        views_count: "",
        subscribers_count: "",
        estimate_earning: "",
        watch_time: "",
    })
    const navigate = useNavigate();

    const url = process.env.REACT_APP_LINK

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/analytics`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await response.json();
            setEmployees(data.data.reverse());
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreImage(URL.createObjectURL(file));
            setImage(file);
        }
    };

    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const AnalyticsOptions = [
        { value: 'Boost View', label: 'Boost View' },
        { value: 'Regular View', label: 'Regular View' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const isEdit = data.id !== undefined;
        const urlmain = isEdit
            ? `${url}/api/analytics/${data.id}`
            : `${url}/api/analytics`;
        const method = isEdit ? "PUT" : "POST";

        try {
            const res = await fetch(urlmain, {
                method,
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data), // no need for headers (browser sets it automatically with boundary)

            });

            const result = await res.json();

            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    user_id: result.user_id,
                    user_name: result.user_name,
                    video_id: result.video_id,
                    video: result.video,
                    views_count: result.views_count,
                    subscribers_count: result.subscribers_count,
                    estimate_earning: result.estimate_earning,
                    view_type: result.view_type,
                    watch_time: result.watch_time
                };

                toast.success(isEdit ? "Analytics updated" : "Analytics added");

                fetchUsers();
                setIsModalOpen(false);

                setData({
                    user_id: "",
                    user_name: "",
                    video_id: "",
                    video: "",
                    views_count: "",
                    subscribers_count: "",
                    estimate_earning: "",
                    view_type: "",
                    watch_time: ""
                });
                setImage(null);
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err);
        }
        finally {
            setLoading(false);
        }
    };


    const handleDelete = (email) => {
        const updatedEmployees = employees.filter(employee => employee.email !== email);
        setEmployees(updatedEmployees);
    };

    const fetchUsersAll = async () => {
        try {
            const response = await fetch(`${url}/api/user/admin1997`);
            const data = await response.json();
            // setEmployees(data)
            setUser(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchVideo = async () => {
        try {
            const response = await fetch(`${url}/api/videos/admin1997`);
            const data = await response.json();
            setVideo(data.reverse());
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsersAll()
        fetchVideo();
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">All Analytics</h1>

                    <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setData({
                            user_id: "",
                            user_name: "",
                            video_id: "",
                            video: "",
                            views_count: "",
                            subscribers_count: "",
                            estimate_earning: "",
                            watch_time: ""
                        });
                    }}>
                        Add Analytics
                    </button>

                </div>
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>User Id</th>
                                <th>Name</th>
                                <th>Title</th>
                                <th>Video Id</th>
                                <th>Play</th>

                                <th>Views</th>
                                <th>Subscribers</th>
                                <th>Estimate Earning</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                        <td>
                                            {employee.user_id}
                                        </td>

                                        <td>{employee.user_name}</td>
<td>{employee.videoData?.title}</td> 
                                        <td>
                                            {/* <div
                                                className="releases-description-cell"
                                                dangerouslySetInnerHTML={{ __html: employee.description }}
                                            /> */}
                                            {employee.video_id}
                                        </td>
{/* <td>
  {employee.videoData?.youtube_video_link ? (
    <a 
      href={employee.videoData.youtube_video_link} 
      target="_blank" 
      rel="noopener noreferrer"
      style={{color:"blue", textDecoration:"underline"}}
    >
      Play
    </a>
  ) : "No Link"}
</td> */}




<td
  style={{
    textAlign: "center",
    verticalAlign: "middle",
    height: "60px", // optional, better visual balance
  }}
>
  {employee.videoData?.youtube_video_link ? (
    <button
      onClick={() => {
        window.open(`${employee.videoData?.youtube_video_link}?autoplay=1`, "_blank");
      }}
      style={{
        backgroundColor: "#2563eb",
        color: "white",
        border: "none",
        borderRadius: "8px",
        padding: "6px 12px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto", // centers button horizontally
      }}
    >
      ▶
    </button>
  ) : (
    <span style={{ display: "block", textAlign: "center" }}>N/A</span>
  )}
</td>
                                        <td>{employee.views_count}</td>
                                        <td>{employee.subscribers_count}</td>
                                        <td>{employee.estimate_earning}</td>

                                        <td>{new Date(employee.createdAt).toLocaleString()}</td>
                                        <td>
                                            {/* <button className="edit-button"
                                                onClick={() => {
                                                    setPreImage(employee.image)
                                                    setData({
                                                        id: employee.id, // include ID for PUT request
                                                        user_id: employee.user_id,
                                                        user_name: employee.user_name || "",
                                                        video_id: employee.video_id || "",
                                                        views_count: employee.views_count || "",
                                                        subscribers_count: employee.subscribers_count || "",
                                                        estimate_earning: employee.estimate_earning || "",
                                                        // win_amount: employee.win_amount || ""
                                                    });

                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button className="delete-button">
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button> */}
                                            <button action="Analytics" onClick={() => navigate(`/analytics/${employee.user_id}/${employee.video_id}`)}>
                                                <i class="fa-solid fa-eye"></i>
                                            </button>
                                        </td>
                                        {/* <td>
                                            
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i className="fa-solid fa-chevron-left"></i><i className="fa-solid fa-chevron-left"></i>
                    </button>

                    <button className="active">{currentPage}</button>

                    {currentPage + 1 < totalPages && (
                        <>
                            <button onClick={() => paginate(currentPage + 1)}>
                                {currentPage + 1}
                            </button>
                            {currentPage + 2 < totalPages && <span className="dots">...</span>}
                            <button onClick={() => paginate(totalPages)}>
                                {totalPages}
                            </button>
                        </>
                    )}

                    {currentPage === totalPages - 1 && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i className="fa-solid fa-chevron-right"></i><i className="fa-solid fa-chevron-right"></i>
                    </button>
                </div>

            </div>
            <AnalyticsModal isOpen={isModalOpen} setIsOpen={setIsModalOpen}
                couponform={data}
                image={image}
                preImage={preImage}
                setCouponForm={setData}
                handleSubmit={handleSubmit}
                statusOptions={statusOptions}
                handleChange={handleChange}
                handleThumbnailChange={handleThumbnailChange}
                setData={setData}
                user={user}
                video={video}
                AnalyticsOptions={AnalyticsOptions}
                loading={loading}
            />
        </>
    );
};

export default Analytics;
